import axiosInstance from './axiosConfig';
import { handleApiError } from '../../utils/errorHandling';

export interface PromptSignal {
  key?: string;
  label?: string;
  term?: string;
  count: number;
  rate?: number;
}

export interface NeededStyleCandidate {
  key?: string;
  name: string;
  prompt_count: number;
  current_style_count: number;
  reason: string;
  keywords?: string[];
}

export interface NgImprovementCandidate {
  key?: string;
  label: string;
  severity: 'high' | 'medium' | 'low' | string;
  count: number;
  recommendation: string;
}

export interface SafePromptSample {
  source_table: string;
  source_id: string;
  prompt: string;
  was_redacted: boolean;
  created_at: string | null;
}

export interface BannerPromptWeeklyReport {
  id: number;
  period_start: string;
  period_end: string;
  generation_source: string;
  source_rows_count: number;
  jobs_count: number;
  images_count: number;
  usage_categories: PromptSignal[] | null;
  frequent_terms: PromptSignal[] | null;
  needed_style_candidates: NeededStyleCandidate[] | null;
  improvement_candidates: NgImprovementCandidate[] | null;
  style_usage: Array<Record<string, unknown>> | null;
  safe_prompt_samples: SafePromptSample[] | null;
  metadata: Record<string, unknown> | null;
  report_markdown: string | null;
  generated_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface BannerPromptReportPaginatedResponse {
  data: BannerPromptWeeklyReport[];
  current_page: number;
  last_page: number;
  total: number;
  per_page: number;
}

export interface AnalyzeBannerPromptReportResponse {
  report: BannerPromptWeeklyReport;
  persisted: boolean;
}

export const fetchBannerPromptReports = async (params?: {
  source?: string;
  page?: number;
  per_page?: number;
}): Promise<BannerPromptReportPaginatedResponse> => {
  try {
    const response = await axiosInstance.get('/admin/banner-prompt-reports', { params });
    return response.data.data;
  } catch (error) {
    throw handleApiError(error, 'バナープロンプト週次分析の取得に失敗しました');
  }
};

export const analyzeBannerPromptWeekly = async (data?: {
  start?: string;
  end?: string;
  source?: string;
  dry_run?: boolean;
}): Promise<AnalyzeBannerPromptReportResponse> => {
  try {
    const response = await axiosInstance.post('/admin/banner-prompt-reports/analyze', data ?? {});
    return {
      report: response.data.data,
      persisted: response.data.persisted,
    };
  } catch (error) {
    throw handleApiError(error, 'バナープロンプト週次分析の実行に失敗しました');
  }
};
